import { useContext } from 'react'
import { ConsentsContext } from './context'
import { UseConsents } from './types'

export const useConsents = (): UseConsents => {
  const { consents, setConsents } = useContext(ConsentsContext)
  return [consents, setConsents]
}
